import { Avatar, IconButton, ListItemIcon, Menu, MenuItem } from '@mui/material'
import MenuIcon from '@mui/icons-material/Menu'
import MyleLogoSvg from '../../ui/svg/MyleLogo'
import { useEffect, useState } from 'react'
import { formatTime } from '../../../utils/utils-functions'
import { bindMenu, bindTrigger, usePopupState } from 'material-ui-popup-state/hooks'
import { Logout } from '@mui/icons-material'
import useAppStore from '../../../stores/app'
import { Route, Routes } from 'react-router-dom'
import RidesActions from './PageActions/RidesActions'

const Header = () => {
  const [time, setTime] = useState(formatTime())
  const logout = useAppStore(state => state.logout)
  const user = useAppStore(state => state.user)
  const switchNavigationMenu = useAppStore(state => state.switchNavigationMenu)
  const menuState = usePopupState({ variant: 'popover', popupId: 'user-menu' })

  useEffect(() => {
    const interval = setInterval(() => {
      setTime(formatTime())
    }, 10000)

    return () => clearInterval(interval)
  }, [])

  const handleLogout = () => {
    logout()
  }

  return (
    <header className="header-bar">
      <div className="section">
        <IconButton
          id="drawer-button"
          className="menu-button"
          onClick={switchNavigationMenu}>
          <MenuIcon />
        </IconButton>
        <MyleLogoSvg />
        <div className="page-actions">
          <Routes>
            <Route path="rides" element={<RidesActions />} />
          </Routes>
        </div>
      </div>
      <div className="section">
        <div className="time">
          {time}
        </div>
        <IconButton name="avatar-button" className="avatar-button" {...bindTrigger(menuState)}>
          <Avatar>
            {user?.first_name.charAt(0).toUpperCase()}{user?.last_name.charAt(0).toUpperCase()}
          </Avatar>
        </IconButton>
        <Menu {...bindMenu(menuState)}>
          <MenuItem onClick={handleLogout}>
            <ListItemIcon>
              <Logout fontSize="small" />
            </ListItemIcon>
            Logout
          </MenuItem>
        </Menu>
      </div>
    </header>
  )
}

export default Header
